import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import SocialSharing from 'vue-social-sharing';
import { useHistoryBack } from './mixins/historyBack';
import VueLazyLoad from 'vue3-lazyload';
import errorimage from '../public/assets/img/photo/noimg.png';
import Footer from './components/Footer.vue';
import ActionButton from './components/ActionButton.vue';
import loading from '@/helpers/loading';
import VueConfetti from 'vue-confetti';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { DatePicker } from 'vant';

const app = createApp(App);

app.use(VueLazyLoad, {
  error: errorimage,
});

import TrimDirective from './directives/trim';
import NumberDirective from './directives/number';
import CardNumberDirective from './directives/cardNumber';
import expirationDateDirective from './directives/expirationDate';
import MaxLenghtDirective from './directives/maxlength';
import KatakanaDirective from './directives/katakana';
import SpaceDirective from './directives/space';
import EmailDirective from './directives/email';
import HiraganaDirective from './directives/hiragana';
import AlphabetAndNumericHalfsizeDirective from './directives/alphabetAndNumericHalfsize';

app.directive('trim', TrimDirective);
app.directive('number', NumberDirective);
app.directive('cardNumber', CardNumberDirective);
app.directive('expirationDate', expirationDateDirective);
app.directive('maxlength', MaxLenghtDirective);
app.directive('katakana', KatakanaDirective);
app.directive('space', SpaceDirective);
app.directive('email', EmailDirective);
app.directive('hiragana', HiraganaDirective);
app.directive('alphabetAndNumericHalfsize', AlphabetAndNumericHalfsizeDirective);
//global prototype
app.config.globalProperties.$loading = loading;
app.config.globalProperties.historyBack = useHistoryBack().historyBack;


app.component('Footer', Footer);
app.component('ActionButton', ActionButton);

app.use(VueConfetti);
app.use(DatePicker);
app.use(SocialSharing);
app.use(VueGoogleMaps);
app.use(router).use(store).mount('#app');
